module.exports = "/_dynamic/_next/static/images/500.main-327bdcbf9e48efc1f9ba3b37eeefae09.png";